import { render, staticRenderFns } from "./Country.vue?vue&type=template&id=542e52b7&scoped=true&"
import script from "./Country.vue?vue&type=script&lang=js&"
export * from "./Country.vue?vue&type=script&lang=js&"
import style0 from "./Country.vue?vue&type=style&index=0&id=542e52b7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "542e52b7",
  null
  
)

export default component.exports